export default __webpack_public_path__ + "static/media/carousel-help.e77f8133.jpg";